const origin = 'https://sep.seikosportstech.co.uk';
export const UPDATE_ORIGIN = origin;

export function validateMobileUpdate(manifest, runtime) {
  return !!manifest && /^[a-f0-9]{64}$/.test(runtime || '') &&
    manifest.schema === 1 && manifest.appId === 'uk.co.seikosportstech.sep' &&
    manifest.runtime === runtime && /^web-[a-f0-9]{64}$/.test(manifest.bundleId || '') &&
    manifest.url === `${origin}/mobile-updates/${runtime}/${manifest.bundleId}.zip` &&
    typeof manifest.signature === 'string' && /^[A-Za-z0-9+/]{342}==$/.test(manifest.signature) &&
    typeof manifest.checksum === 'string' && /^[A-Za-z0-9+/]{43}=$/.test(manifest.checksum);
}

export async function prepareMobileUpdate({ updater, fetchManifest, builtInId }) {
  const { channel: runtime } = await updater.getChannel();
  if (!/^[a-f0-9]{64}$/.test(runtime || '')) return 'unsupported';
  const manifest = await fetchManifest(runtime);
  if (!validateMobileUpdate(manifest, runtime)) return 'unavailable';
  const [current, next, blocked] = await Promise.all([
    updater.getCurrentBundle(), updater.getNextBundle(), updater.getBlockedBundles(),
  ]);
  if (blocked.bundleIds.includes(manifest.bundleId)) return 'blocked';
  if (manifest.bundleId === (current.bundleId || builtInId)) return 'current';
  if (manifest.bundleId === next.bundleId) return 'pending';
  const downloaded = await updater.getDownloadedBundles();
  if (!downloaded.bundleIds.includes(manifest.bundleId)) {
    await updater.downloadBundle({ bundleId: manifest.bundleId, url: manifest.url,
      checksum: manifest.checksum, signature: manifest.signature, artifactType: 'zip' });
  }
  // Never reload a running form. The native plugin activates this on the next cold start.
  await updater.setNextBundle({ bundleId: manifest.bundleId });
  return 'downloaded';
}
